export default [
  {
    path: "/page", // 登录
    component: resolve => require(["@/pages/wxmp/direct"], resolve),
    name: "首页"
  },
  {
    path: "/mobile", // 登录
    component: resolve => require(["@/pages/wxmp/mobile"], resolve),
    name: "首页"
  },
  {
    path: "/difuUpgradeSign", // 登录
    component: resolve => require(["@/pages/wxmp/sign"], resolve),
    name: "首页"
  },
  {
    path: "/jumpwx", // 登录
    component: resolve => require(["@/pages/wxmp/jumpwx"], resolve),
    name: ""
  },
  {
    path: "/toWx", // 通用微信跳转，可传路径和参数
    component: resolve => require(["@/pages/wxmp/toWx"], resolve)
  },
  {
    path: "/rdt", // 通用微信跳转，可传路径和参数
    component: resolve => require(["@/pages/wxmp/rdt"], resolve)
  },
  {
    path: "/openwx", // 统一打开小程序
    component: resolve => require(["@/pages/wxmp/openwx"], resolve),
    name: ""
  },
  {
    path: "/ksVer", // 快手验证码
    component: resolve => require(["@/pages/wxmp/ksVer"], resolve),
    name: ""
  },
  {
    path: "/ksBack", // 快手返回
    component: resolve => require(["@/pages/wxmp/ksBack"], resolve),
    name: ""
  },
  {
    path: "/wenlv", // 测试页面
    component: resolve => require(["@/pages/wxmp/wenlv"], resolve),
    name: "测试页面"
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/wxmp.js